import { newLayout } from '../theme';

export default {
  styleOverrides: {
    root: {
      borderRadius: newLayout.borderRadius.secondary,
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: newLayout.border.default.color,
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderWidth: '1px',
      },
      '&:not(.Mui-disabled):not(.Mui-error):not(.MuiInputBase-colorSuccess):hover .MuiOutlinedInput-notchedOutline':
        {
          borderColor: newLayout.border.hover.color,
        },
      '&:not(.Mui-disabled):not(.Mui-error):not(.MuiInputBase-colorSuccess).Mui-focused .MuiOutlinedInput-notchedOutline':
        {
          borderColor: newLayout.border.active.color,
        },
      '&.Mui-disabled .MuiOutlinedInput-notchedOutline, &.Mui-disabled .MuiOutlinedInput-input':
        {
          borderColor: newLayout.border.disabled.color,
        },
      '&.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: newLayout.border.error.color,
      },
      '&.MuiInputBase-colorSuccess .MuiOutlinedInput-notchedOutline': {
        borderColor: newLayout.border.success.color,
      },
    },
  },
};
